import { z } from 'zod'

export const UpdateLineItemSchema = z.object({
    cart_id: z.string().min(1),
    line_id: z.string().min(1),
    quantity: z.number().max(1).min(1),
})
